import type { PartnerOrganization } from "@entities";
import { partnerOrganizationRepo } from "@repositories";

export async function loadPartnerOrganizationForDetails(
  partnerOrganizationId: string,
  partnerOrganization?: PartnerOrganization | null,
): Promise<PartnerOrganization | null> {
  if (
    partnerOrganization?.id === partnerOrganizationId &&
    partnerOrganization.addresses
  ) {
    return partnerOrganization;
  }
  return (
    (await partnerOrganizationRepo.findId(partnerOrganizationId, {
      include: {
        managers: true,
        handlingManager: true,
        organizationManagers: { include: { manager: true } },
        addresses: true,
      },
    })) || null
  );
}
